<div class="force-reset-dialog">
  <div *ngIf="step === 1" class="dialog-step">
    <div class="dialog-icon">
      <mat-icon color="warn">security</mat-icon>
    </div>
    <h2 class="dialog-title" translate>Security Upgrade Required</h2>
    <p class="dialog-message" translate>
      We've upgraded Artaah authentication and account security to align with
      the Fly+ identity platform. As part of this update, you're required to
      reset your password once before continuing. Your account details,
      bookings, and history remain unaffected.
    </p>

    <div *ngIf="error" class="api-error mb-3">{{ error }}</div>

    <button
      mat-flat-button
      color="primary"
      class="w-100 action-btn"
      [disabled]="loading.sending"
      (click)="startReset()"
    >
      <span translate>Reset Password</span>
      <app-loader
        class="d-inline-flex"
        [isLoading]="loading.sending"
      ></app-loader>
    </button>

    <p class="dialog-footer" translate>
      If you experience any issues, please contact support.
    </p>
  </div>

  <div *ngIf="step === 2" class="dialog-step text-center">
    <h2 class="dialog-title" translate>Verify your email</h2>
    <p class="dialog-message">
      <span translate>We sent a verification code to</span>
      <strong> {{ data.email }}</strong>
    </p>

    <div class="d-flex justify-content-center my-3">
      <ng-otp-input
        [formCtrl]="otpControl"
        [config]="otpConfig"
        dir="ltr"
      ></ng-otp-input>
    </div>

    <div *ngIf="error" class="api-error mb-2">{{ error }}</div>

    <div class="resend-section text-secondary mb-3">
      <div translate>Didn't receive the code?</div>
      <span *ngIf="isTimerActive" class="fw-bold">
        <span translate>Resend in </span>{{ getTimerText(timer) }}
      </span>
      <a
        class="resend-link c-pointer"
        *ngIf="!isTimerActive && !loading.resending"
        (click)="resendOtp()"
        translate
        >Resend code</a
      >
      <app-loader
        class="d-inline-flex"
        [isLoading]="loading.resending"
      ></app-loader>
    </div>

    <button
      mat-flat-button
      color="primary"
      class="w-100 action-btn"
      [disabled]="loading.verifying || (otpControl.value?.length ?? 0) < 6"
      (click)="verifyOtp()"
    >
      <span translate>Verify</span>
      <app-loader
        class="d-inline-flex"
        [isLoading]="loading.verifying"
      ></app-loader>
    </button>
  </div>

  <div *ngIf="step === 3" class="dialog-step">
    <h2 class="dialog-title" translate>Set New Password</h2>
    <p class="dialog-message" translate>
      Choose a strong password to secure your account.
    </p>

    <form [formGroup]="passwordForm">
      <mat-label class="field-label">
        <span translate>New password</span> <sup>*</sup>
      </mat-label>
      <mat-form-field appearance="outline" class="w-100">
        <input
          matInput
          [type]="showNew ? 'text' : 'password'"
          formControlName="newPassword"
          [placeholder]="'Enter your new password' | translate"
          autocomplete="new-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="showNew = !showNew"
        >
          <mat-icon>{{ showNew ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="newPasswordErrors">{{
          newPasswordErrors | translate
        }}</mat-error>
      </mat-form-field>

      <mat-label class="field-label">
        <span translate>Confirm password</span> <sup>*</sup>
      </mat-label>
      <mat-form-field
        appearance="outline"
        class="w-100"
        [class.field-error]="showMismatchError"
      >
        <input
          matInput
          [type]="showConfirm ? 'text' : 'password'"
          formControlName="confirmPassword"
          [placeholder]="'Re-enter your new password' | translate"
          autocomplete="new-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="showConfirm = !showConfirm"
        >
          <mat-icon>{{
            showConfirm ? 'visibility_off' : 'visibility'
          }}</mat-icon>
        </button>
      </mat-form-field>

      <div *ngIf="showMismatchError" class="inline-error">
        <mat-icon class="inline-error__icon">error_outline</mat-icon>
        <span translate
          >Passwords do not match. Please re-enter your new password to
          confirm.</span
        >
      </div>

      <div *ngIf="error" class="api-error mt-2">{{ error }}</div>
    </form>

    <button
      mat-flat-button
      color="primary"
      class="w-100 action-btn mt-3"
      [disabled]="loading.resetting"
      (click)="resetPassword()"
    >
      <span translate>Confirm Reset</span>
      <app-loader
        class="d-inline-flex"
        [isLoading]="loading.resetting"
      ></app-loader>
    </button>
  </div>
</div>
